import * as React from "react";

import Grid from "@mui/material/Grid";
import type { SvgIconProps } from "@mui/material/SvgIcon";

import type { IntlShape } from "@mnemonic/intl";
import { defineMessages } from "@mnemonic/intl";
import CardError from "@mnemonic/mui/CardError";
import CardTitleError from "@mnemonic/mui/CardTitleError";
import { ErrorIcon } from "@mnemonic/mui/icons";

const messages = defineMessages({
  subtitle: {
    defaultMessage: "Query parameters undefined",
    description: "Text for error card on User Authorization page",
    id: "mne-authentication.userauthorization.undefined.parameters",
  },
});

const IconComponent = ErrorIcon as unknown as React.FC<SvgIconProps>;

interface IErrorCardQueryParameters {
  intl: IntlShape;
}

const ErrorCardQueryParameters = ({ intl }: IErrorCardQueryParameters) => {
  const { formatMessage } = intl;

  return (
    <Grid container spacing={1} sx={{ justifyContent: "center", alignItems: "center" }}>
      <div style={{ width: "30%" }}>
        <CardError>
          <CardTitleError Icon={IconComponent} colorIcon={"action"} subtitle={formatMessage(messages.subtitle)} />
          <br />
        </CardError>
      </div>
    </Grid>
  );
};

export default ErrorCardQueryParameters;
